import { StringHelper } from "../../../../../../helper";
import { AFLType } from "../../models";

export const form40 = (record: any) => {
  return {
    departmentCode: "3",
    aflType: AFLType.ApplicationForLeave,
    layout: [
      {
        type: "header",
        value: {
          form: 1,
          department: "CHI NHÁNH ĐÀ NẴNG",
        },
      },
      {
        type: "title",
        value: {
          sub: [`(Dành cho Nhân viên nghỉ phép ngoài nước)`],
        },
      },
      {
        type: "salutation",
        value: ["Giám đốc Chi nhánh Đà Nẵng;", "Trưởng phòng/Trung tâm....."],
      },
      {
        type: "content",
        value: [
          { type: "eRequestName", value: record?.eRequestName },
          {
            type: "ePosition",
            value: StringHelper.verticalBarSplit<string[]>(record?.eTitle)[1],
          },
          {
            type: "eWorkPlaceDeptCenter2",
            value: StringHelper.verticalBarSplit<string[]>(record?.eUnit)[1],
          },
          {
            type: "",
            value: `Nay tôi làm đơn này kính đề nghị Giám đốc, Trưởng phòng/Trung tâm...... đồng ý giải quyết cho tôi được nghỉ phép năm ${new Date().getFullYear()} lần thứ ${
              record?.ePaidLeaveTimes || ""
            }.`,
          },
          {
            type: "",
            value: `Số lượng phép theo tiêu chuẩn: ${
              record?.ePaidLeaveRemain + "" || ""
            } ngày (trong TH nghỉ phép từ lần thứ 2 trở đi, chỉ ghi rõ số ngày phép còn lại chưa thực hiện).`,
          },

          { type: "eVacationPeriod", value: record?.eVacationPeriods[0] },
          { type: "eLeavePlace", value: record?.eLeavePlace || "" },
          { type: "ePhoneNumber", value: record?.ePhone || "" },
          { type: "eReason", value: record?.eReason },
          {
            type: "",
            value: "Rất mong nhận được sự chấp thuận của Giám đốc chi nhánh, Trưởng phòng/Trung tâm.",
          },
          { type: "", value: "Xin trân trọng cảm ơn./." },
        ],
      },
      {
        type: "footer",
        value: [
          {
            type: "signature1",
            value: ["TRƯỞNG PHÒNG KHHC", record?.eSteps[2][0].name],
          },
          {
            type: "signature1",
            value: ["TRƯỞNG PHÒNG/TRUNG TÂM", record?.eSteps[1][0].name],
          },
          {
            type: "signature1",
            value: ["NGƯỜI LÀM ĐƠN", record?.eRequestName],
          },
        ],
        textBreak: 1,
      },
      {
        type: "footer",
        value: [
          {
            type: "signature1",
            value: ["PHÊ DUYỆT CỦA GIÁM ĐỐC CHI NHÁNH", record?.eSteps[3][0].name],
          },
        ],
        textBreak: 1,
      },
      {
        type: "footer",
        value: [
          {
            type: "recipients",
            value: ["- Như trên;", "- Lưu: KHHC."],
          },
          {
            type: "signature1",
            value: [],
          },
        ],
      },
    ],
  };
};
